import { Headline2, Paragraph4 } from '@nexus/lib-react/dist/core/Typography';
import ButtonTertiaryDark from '@nexus/lib-react/dist/core/Button/ButtonTertiaryDark';
import mq from '../../../../../../commons/styles/mediaQueries';
import styled from '../../../../../../theme/styled';

const LayoutContainer = styled.div`
  display: flex;
  flex-direction: column;
  background-color: #f2f4f5;
  border-radius: ${({ theme }) => theme.radii.primary};
  ${mq.desktop} {
    padding: 24px 32px 32px;
  }
`;

const UpperLayer = styled.div`
  background-color: #ffffff;
  ${mq.desktop} {
    margin-bottom: 24px;
    padding: 0px;
  }
`;

const LowerLayer = styled.div`
  display: flex;
  flex-direction: column;
  background-color: #ffffff;
  ${mq.desktop} {
    flex-direction: row;
  }
`;

const StartContainerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background-color: #ffffff;
  padding: 16px;
  ${mq.desktop} {
    padding: 16px 32px;
    border-right: 1px solid ${({ theme }) => theme.colors['borders-global-tertiary']};
  }
`;

const CTALayer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: calc(20vh);
  padding: 16px;
  ${mq.desktop} {
    flex-direction: row;
    justify-content: flex-end;
    position: static;
  }
`;

const ContentWrapper = styled.section`
  font-family: ${({ theme }) => theme.fonts.primary};
  background-color: ${({ theme }) => theme.colors.bgPrimary};
  padding: 16px;
  margin-bottom: 8px;
  ${mq.desktop} {
    display: none;
  }
`;

const StartContainer = styled.div`
  ${mq.desktop} {
    width: 100%;
    padding: 16px 96px 32px 32px;
    border-radius: 4px;
    border-right: 1px solid ${({ theme }) => theme.colors['borders-global-tertiary']};
  }
`;

const EndContainer = styled.div`
  display: none;
  ${mq.desktop} {
    padding: 32px;
    width: 100%;
    display: initial;
    padding-left: 96px;
  }
`;

const MobileHeadline = styled(Headline2)`
  ${mq.desktop} {
    display: none;
  }
`;

const DesktopHeadline = styled(Headline2)`
  display: none;
  ${mq.desktop} {
    display: block;
    margin: 16px 0px;
  }
`;

const MobileDescription = styled(Paragraph4)`
  ${mq.desktop} {
    display: none;
  }
`;

const Link = styled(ButtonTertiaryDark)`
  > span {
    margin-left: 8px;
  }
`;

const Icon = styled.div`
  margin-right: 8px;
`;

export default {
  LayoutContainer,
  UpperLayer,
  LowerLayer,
  StartContainerWrapper,
  CTALayer,
  ContentWrapper,
  StartContainer,
  EndContainer,
  MobileHeadline,
  DesktopHeadline,
  MobileDescription,
  Link,
  Icon,
};
